export default __webpack_public_path__ + "static/media/if-goiano.a9003b79.png";